import { isSameYear } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { getLocalTimezone } from 'lib/time'

export function formatBillRateShiftDateTime(
  date: string,
  timezone: string | null,
  now: Date = new Date()
): string {
  const timeZone = timezone || getLocalTimezone()
  const includeYear = !isSameYear(new Date(date), now)
  return formatInTimeZone(
    date,
    timeZone,
    includeYear ? 'EEE MMM, dd, yyyy, hh:mm a zz' : 'EEE MMM, dd, hh:mm a zz'
  )
}
